import SysColumn from "app/class/sys-column";

export const DEFAULT_REQUIRED_FIELD_MESSAGE = "This field is required";

export const buildRequiredRule = (
    isRequired?: boolean,
    message: string = DEFAULT_REQUIRED_FIELD_MESSAGE
) => {
    if (!isRequired) {
        return false;
    }

    return message;
};

export const getRequiredFieldMessage = (
    _column?: SysColumn,
    fallback: string = DEFAULT_REQUIRED_FIELD_MESSAGE
) => fallback;
